import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <Link to="/" className="logo">
            <img src="/decode-logo.png" alt="Decode Logo" className="logo-image" />
            <span className="logo-text">Decode Fellowship Program</span>
          </Link>

          <div className={`nav-menu ${isMenuOpen ? 'nav-menu-active' : ''}`}>
            <Link
              to="/"
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`nav-link ${isActive('/about') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </Link>
            <Link
              to="/faq"
              className={`nav-link ${isActive('/faq') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              FAQ
            </Link>
            <a
              href="https://forms.fillout.com/t/hHZE5TwMiuus"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link btn btn-primary"
              onClick={() => setIsMenuOpen(false)}
            >
              Join as a Fellow
            </a>
          </div>

          <div className="hamburger" onClick={toggleMenu}>
            <span className={`bar ${isMenuOpen ? 'active' : ''}`}></span>
            <span className={`bar ${isMenuOpen ? 'active' : ''}`}></span>
            <span className={`bar ${isMenuOpen ? 'active' : ''}`}></span>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;